import { createUseExternalEvents } from '@mantine/utils';
import type { SpotlightEvents } from './types';

export const [useSpotlightEvents, createEvent] =
	createUseExternalEvents<SpotlightEvents>('cmd-k');

export const openSpotlight = createEvent('open');
export const closeSpotlight = createEvent('close');
export const toggleSpotlight = createEvent('toggle');
